"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(func) {
  var didRun = false;
  var result;
  return function onced() {
    if (!didRun) {
      didRun = true;
      result = func.apply(void 0, arguments);
    }

    return result;
  };
};

exports.default = _default;
module.exports = exports.default;